export default __webpack_public_path__ + "static/sustainability-3-9f34c3e4c0cc18ec2aba4e836206af9d.jpg";